import React, { useState } from 'react';
import { X } from 'lucide-react';
import { useSiteContent } from '../context/SiteContext';
import './Gallery.css';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const { gallery } = useSiteContent();

  const resolveUrl = (img) => {
    if (img.storagePath) return `${API_URL}/api/public/files/${img.storagePath}`;
    return img.url;
  };

  const images = (gallery?.images || []).sort((a, b) => (a.order || 0) - (b.order || 0));

  const openLightbox = (image) => {
    setSelectedImage(image);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setSelectedImage(null);
    document.body.style.overflow = 'auto';
  };

  return (
    <section className="gallery section-padding" data-testid="gallery-section">
      <div className="container">
        <div className="gallery-header">
          <span className="gallery-label">{gallery?.sectionLabel || 'Impressionen'}</span>
          <h2 className="heading-1">{gallery?.sectionTitle || 'Erleben Sie unsere Location'}</h2>
          <p className="body-large space-top-md">{gallery?.sectionDescription || ''}</p>
        </div>

        <div className="gallery-grid space-top-xxl">
          {images.map((image, index) => (
            <div key={image.id || index} className="gallery-item" onClick={() => openLightbox(image)}>
              <div className="gallery-image-wrapper">
                <img src={resolveUrl(image)} alt={image.alt || image.title} className="gallery-image" loading="lazy" />
                <div className="gallery-overlay">
                  <span className="gallery-item-title">{image.title}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {selectedImage && (
        <div className="lightbox" onClick={closeLightbox}>
          <button className="lightbox-close" onClick={closeLightbox} aria-label="Schliessen">
            <X size={32} />
          </button>
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <img src={resolveUrl(selectedImage)} alt={selectedImage.alt || selectedImage.title} className="lightbox-image" />
            <p className="lightbox-title">{selectedImage.title}</p>
          </div>
        </div>
      )}
    </section>
  );
};

export default Gallery;
